import {RootState} from "./store";

export const QueryParamSelector = (state: RootState) => new URLSearchParams(state.router.location.query);

export const rootSelector = (state: RootState) => state